<template>
  <validation-observer ref="registerForm" #default="{ invalid }">
    <b-form>
      <b-row>
        <b-col lg="12">
          <b-form-group
            id="input-group-1"
            :label="$t('rooms.name')"
            label-for="input-1"
          >
            <validation-provider
              #default="{ errors }"
              name="name"
              vid="name"
              rules="required"
            >
              <b-form-input
                id="input-1"
                v-model="newItem.name"
                type="text"
                :state="errors.length > 0 ? false : null"
                :placeholder="$t('rooms.name')"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <!-- .edu_program -->
        <b-col lg="12">
          <b-form-group
            id="input-group-2"
            :label="$t('edu_programs.edu_program')"
            label-for="input-2"
            ><validation-provider
              #default="{ errors }"
              name="eduProgram"
              vid="eduProgram"
              rules="required"
            >
              <b-form-select
                id="input-1"
                v-model="newItem.edu_program_id"
                :options="edu_program"
                :state="errors.length > 0 ? false : null"
                text-field="for_v_select"
                value-field="id"
                :placeholder="$t('edu_programs.edu_program')"
              ></b-form-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <!-- .students_online_class -->
      </b-row>
      <hr />
      <b-row>
        <b-col lg="6">
          <b-button
            block
            :disabled="invalid"
            variant="primary"
            @click="submit()"
          >
            <i class="fa fa-plus" /> {{ $t("site.save") }}</b-button
          >
        </b-col>
        <b-col lg="6">
          <b-button block @click="goToTable()" variant="success">
            <i class="fas fa-ban"></i> {{ $t("site.cancel") }}</b-button
          >
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import Controller from "../../../../Controllers/RoomsController";
import config from "../../../../config/config";
import EduProgramsController from "@/Controllers/EduProgramsController";
import { ValidationProvider, ValidationObserver } from "vee-validate";

import { required } from "@validations";

export default {
  name: "RoomsForm",
  components: { ValidationProvider, ValidationObserver, required },
  props: ["newItem"],
  data() {
    return {
      file: {},
      
      edu_program: [],
    };
  },
  async created() {
    this.edu_program = await new EduProgramsController().GetAll();
    this.edu_program.forEach((el) => {
      el.for_v_select = el.code + "-" + el.name;
    });
  },
  methods: {
    async goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      delete this.newItem.students;
      delete this.newItem.eduProgram;
      delete this.newItem.teachers;
    
      let ret = await new Controller().From(this.newItem, "FormData");
      if (ret) {
        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        this.$parent.$parent.firstTab();
      }
    },
  },
};
</script>
